export default "__VITE_ASSET__DNdKJRvE__"